import React from 'react';
import Button from '@mui/material/Button/Button'
import '../BlogSection.css';


const BlogPost = ({blog}) => {
    return (
        <div className="card shadow-lg d-flex flex-column justify-content-between mx-4 h-100">
            <div className="mb-2">
                <img src={blog.image} alt={blog.title} className="w-100"/>
            </div>
            <div className="mt-3 mb-4 px-3">
                <h5 className="blog__content__heading">{blog.title}</h5>
            </div>
            <hr/>
            <div className="my-2 px-3 blog__content">
                <p>
                    {blog.description}
                </p>
            </div>
            <Button color="primary" type="filled">
                Learn More
            </Button>
        </div>
    )
}

export default BlogPost;


